// extracted by mini-css-extract-plugin
export default {"loader":"InputLoader_loader__vUwZQ","spin":"InputLoader_spin__3VhzF"};